import { render, staticRenderFns } from "./ProductThumbnail.vue?vue&type=template&id=cd5525ea&"
import script from "./ProductThumbnail.js?vue&type=script&lang=js&"
export * from "./ProductThumbnail.js?vue&type=script&lang=js&"
import style0 from "./ProductThumbnail.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ProductThumbnail.txt?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fopt%2Fbuild%2Frepo%2Fsrc%2Fcomponents%2Fcommon%2FProductThumbnail%2FProductThumbnail.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports